module.exports = __webpack_public_path__ + "img/logo-alepay.7e1cc43c.jpg";